// extracted by mini-css-extract-plugin
export var tosLink = "_an-0";